import { IFirstPaymentDefinition } from '@entities/firstPaymentDefinition/@/tourProduct';
import TourProduct from '../model/TourProduct';

export default function (groupedTourProducts: TourProduct[][]): IFirstPaymentDefinition[][] {
    const prepayments = groupedTourProducts.map((tourProducts) => tourProducts.reduce((acc, tourProduct) => {
        if (tourProduct.firstPaymentDefinitions?.length) {
            acc.push(...tourProduct.firstPaymentDefinitions);
        }
        return acc;
    }, [] as IFirstPaymentDefinition[]));
    return prepayments;
}
